import script from "./PCPartsDetailsCardArticlesExpected.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardArticlesExpected.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardArticlesExpected.vue?vue&type=style&index=0&id=5d6131d8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6131d8"]])

export default __exports__